import { atom } from 'jotai'

export type ApiEnvironment = 'live' | 'dev'

const STORAGE_KEY = 'fg_api_environment'

declare global {
    interface Window {
        __API_ENV__?: ApiEnvironment
    }
}

const getInitialEnvironment = (): ApiEnvironment => {
    if (typeof window === 'undefined') return 'live'
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'dev' || stored === 'live') {
        window.__API_ENV__ = stored
        return stored
    }
    window.__API_ENV__ = 'live'
    return 'live'
}

const baseApiEnvironmentAtom = atom<ApiEnvironment>(getInitialEnvironment())

export const apiEnvironmentAtom = atom(
    get => get(baseApiEnvironmentAtom),
    (_get, set, newValue: ApiEnvironment) => {
        set(baseApiEnvironmentAtom, newValue)
        localStorage.setItem(STORAGE_KEY, newValue)
        if (typeof window !== 'undefined') {
            window.__API_ENV__ = newValue
        }
    }
)

export const getCurrentApiEnvironment = (): ApiEnvironment => {
    if (typeof window === 'undefined') return 'live'
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'dev' || stored === 'live') return stored
    return 'live'
}

if (typeof window !== 'undefined') {
    window.__API_ENV__ = getCurrentApiEnvironment()
}
